import { DocTranslationDto, TranslationKey } from "../entities";

export function extractDefaultTranslationKey(
  translations: DocTranslationDto[]
): TranslationKey | undefined {
  const translation = translations.find(({ isDefault }) => isDefault);
  return translation?.transKey as TranslationKey | undefined;
}
